// // ADDED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const leaveRequestService = {
  getByEmployee: async (employeePersonalInformationId) => {
    return await axios.get(`${domain}/api/LeaveRequest/employee/${employeePersonalInformationId}`, { headers });
  },

  create: async (payload) => {
    console.log("Creating leave request with payload:", payload);
    return await axios.post(`${domain}/api/LeaveRequest`, payload, { headers });
  },

  // TODO: Add update and delete methods if needed in the future
  // Add the Approved/Rejected logic here as well since it's closely tied to the request creation

  // Logic moved from legacy component to service
  createApproval: async (requestId, requestTypeId) => {
    const data = {
      requestId,
      requestTypeId,
      primaryApproverStatus: "Pending",
      secondaryApproverStatus: "Pending",
      tertiaryApproverStatus: "Pending",
    };
    return await axios.post(`${domain}/api/Approval/0`, data, { headers });
  },

  // Keep SMS logic here for now as requested
  sendSmsNotification: async (data, employeeName, contacts) => {
    if (!contacts || contacts.length === 0) return;

    const formattedRef = data.referenceNumber.toString().padStart(6, "0");
    const message = `Hello,\n\n${employeeName} filed a Leave Request.\n\nPlease check reference number LV-${formattedRef} in the portal.`;

    const smsPromises = contacts.map(contact => {
      const smsData = {
        requestTypeId: 1,
        date: new Date(),
        message,
        recipientId: contact.id,
        recipientFullName: contact.fullName,
        recipientMobileNumber: contact.phoneNumber,
      };
      // Note: IP-based call from legacy code
      return axios.post("http://161.49.93.114:8081/api/Sms/send-sms", smsData);
    });

    return Promise.allSettled(smsPromises);
  }
};

export default leaveRequestService;